// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"390":"fd57fe14","878":"5e3a9d3b"}[chunkId] + ".chunk.css";
};